import React from "react";

const CampaignType = props => {
	const {items, value, onChange} = props;

	if(!items) {
		return <div/>
	}

	return (
		<select className="edit-field-styles select-primary" onChange={(e) => onChange(e.target.selectedOptions[0].value)} value={value || ''}>
			{ items.map((t, i) => (<option value={t.value} key={i}>{t.label}</option>)) }
		</select>
	)
};

export default CampaignType;
